import type { Tool } from '@/types/tool.type';
import type { MCPServerHTTPConfig } from '@/types/tool.type';

type ToolSummaryInput = Pick<Tool, 'config' | 'description' | 'type'>;

export const getToolSummary = (tool: ToolSummaryInput) => {
  const config = tool.config as MCPServerHTTPConfig | null;

  if (config?.url) {
    const transport = config.transport ? config.transport.toUpperCase() : 'HTTP';
    return `${transport} • ${config.url}`;
  }

  return tool.description || `${tool.type} tool`;
};
